<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1889_4707)">
<path opacity="0.3" d="M35.5 15C35.5 15.5523 35.0523 16 34.5 16L26.9 16L26.9 14L34.5 14C35.0523 14 35.5 14.4477 35.5 15Z" fill="currentColor"/>
<rect x="18.9" y="10.7" width="8.6" height="8.6" rx="4.3" stroke="currentColor" stroke-width="1.4"/>
<path d="M2.5 15C2.5 14.4477 2.94772 14 3.5 14H19.5V16H3.5C2.94772 16 2.5 15.5523 2.5 15Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1889_4707">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
